/**
 * React-Serialize utility re-written in TypeScript
 * Originally created by @pravdomil (https://github.com/pravdomil/react-serialize)
 */

export const serialize = (component) => {
  const getName = (value) => {
    if (typeof value === 'string') {
      return value;
    } else if (typeof value === 'function') {
      return value.name;
    }

    return value;
  };

  const replacer = (key, value) => {
    switch (key) {
      case 'type':
        return getName(value); // This part sets the type of the component to the name of the component
      case '_owner':
      case '_store':
      case 'ref':
      case 'key':
        return;

      default:
        return value;
    }
  };

  return JSON.stringify(component, replacer);
};
